<div>
  @if (expandableRowDataField && !expandableRowNestedTable) {
    @if (dataSource?.data?.length) {
      <div class="expandable-panel-list">
        @for (element of dataSource.data; track element.id) {
          <app-main-table-module-specific-template
            [module]="moduleName"
            [specificTemplateName]="specificTemplateName"
            [columnName]="detailsDisplayedColumns[0]"
            [element]="element"
            (click)="handleColumnClick($event, detailsDisplayedColumns[0], element)"
          ></app-main-table-module-specific-template>
        }
      </div>
    } @else {
      <div class="expandable-empty-state">
        {{ expandableRowEmptyLabel | translate }}
      </div>
    }
  } @else {
    <table mat-table matSort [dataSource]="dataSource" class="main-table-container">
      @for (columnName of displayedColumns; track $index) {
        <ng-container [matColumnDef]="columnName">
          <th mat-header-cell *matHeaderCellDef>
            @if (columnName | shouldHeaderBeDisplayed) {
              {{ columnName | translate | uppercase }}
            }
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [ngClass]="{
              'expand-column': columnName === 'expand',
              'standard-column': columnName !== 'expand',
              'single-column-for-logs': moduleName !== 'run-time' && !expandableRowNestedTable,
            }"
          >
            <app-main-table-module-specific-template
              [module]="moduleName"
              [specificTemplateName]="specificTemplateName"
              [columnName]="columnName"
              [element]="element"
              (click)="handleColumnClick($event, columnName, element)"
            ></app-main-table-module-specific-template>
          </td>
        </ng-container>
      }
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="background"
        [class.cdk-visually-hidden]="hideColumns"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="
          moduleName === 'run-time'
            ? 'background pointer-cursor'
            : expandableRowNestedTable
              ? 'background'
              : 'background-for-logs'
        "
        (click)="onNestedRowClick(row)"
      ></tr>
    </table>
  }
</div>
